import {
  faCheckCircle,
  faExclamationCircle,
  faExclamationTriangle,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { twMerge } from "tailwind-merge";

export default function Alert({ type = "info", children, ...props }) {
  const icons = {
    info: faInfoCircle,
    success: faCheckCircle,
    warning: faExclamationTriangle,
    error: faExclamationCircle,
  };

  const colors = {
    info: "text-blue-300",
    success: "text-green-300",
    warning: "text-yellow-300",
    error: "text-red-300",
  };

  const borderColors = {
    info: "border-blue-400",
    success: "border-green-400",
    warning: "border-yellow-400",
    error: "border-red-400",
  }

  const icon = icons[type] ? icons[type] : icons["info"];

  return (
    <div
     {...props}
      className={twMerge(
        "mt-2 relative rounded border-blue-400 border py-2 px-4  font-semibold text-blue-300 flex gap-2 items-center",
        props?.className,colors[type], borderColors[type]
      )}
    >
      <FontAwesomeIcon icon={icon} />
      <p>{children}</p>
    </div>
  );
}
